import styled from 'styled-components';
import ButtonBase from '../base/Base';

const ButtonStandardPrimary = styled(ButtonBase)`
  background-color: ${props => props.theme.colors.primary};
  color: ${props => props.theme.colors.white};
  padding: 1.5rem 2.5rem;
  width: ${props => props.width};
`;

export default ButtonStandardPrimary;



// WEBPACK FOOTER //
// ./src/components/atoms/buttons/standard/Primary.js